import axios from 'axios';

const API_URL = process.env.ROOT_API;

export const http = axios.create({
  baseURL: API_URL
})

http.interceptors.request.use(
  config => {
    config.headers.common['Authorization'] = 'Bearer ' + localStorage.token;
    config.headers.common['Content-Type'] = 'application/json';
//    config.headers.common['Access-Control-Allow-Origin'] = '*';
    return config;
  },
  error => Promise.reject(error)
);

export const httpLogin = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  //  'Access-Control-Allow-Origin': '*',
  }
})



// WEBPACK FOOTER //
// ./src/backend/vue-axios/axios.js